/**
 * @module Utilities/Cache
 * @desc Cache helper funtions
 */

import { getUnixtime } from 'core/utilities/helpers';

/**
 * Check if cache is valid
 */
export function hasValidCache(lastUpdated: number, max = 10) {
  if (!navigator.onLine) {
    return true;
  }

  return lastUpdated + max * 60 > getUnixtime();
}
